/** EN uses Swedish values until translated. */
export const pageNotFoundTranslationsEn = {
    title: '404 - Page not found',
    message: 'The page you tried to reach could not be found.',
}
